import { render, staticRenderFns } from "./AskSide.vue?vue&type=template&id=a08ec224&scoped=true&"
import script from "./AskSide.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskSide.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskSide.vue?vue&type=style&index=0&id=a08ec224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ec224",
  null
  
)

export default component.exports